import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IOrgFilterStrings extends LocalizedStringsMethods {
    lsNameTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;     
}

let strings: IOrgFilterStrings;
export default strings = new LocalizedStrings({
    en: {
        lsNameTxt: 'Name',
        lsContactFirstNameTxt: 'Contact First Name',    
        lsContactLastNameTxt: 'Contact Last Name',   
        lsContactPhoneTxt: 'Contact Phone',
        lsContactEmailTxt: 'Contact Email',
    },
    es: {
        lsNameTxt: 'Nombre',
        lsContactFirstNameTxt: 'Contact First Name',    
        lsContactLastNameTxt: 'Contact Last Name',   
        lsContactPhoneTxt: 'teléfono de contacto',
        lsContactEmailTxt: 'Email de contacto', 
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/organization/string.organization.filter.tsx